export default "__VITE_ASSET__BZE$211q__"